import { createApi } from '@redux/createApi';

// Параметры передаём через params: axios сам закодирует адрес с / и +.
// Ключ counterparty не собираем и адрес не нормализуем — бэкенд принимает network + address как есть.
export const cryptoAddressesApi = createApi({
  reducerPath: 'cryptoAddressesApi',
  tagTypes: ['CryptoAddresses', 'CryptoAddressCard', 'CryptoAddressBlacklist'],
  endpoints: (builder) => ({
    getCryptoAddresses: builder.query({
      query: (params) => ({ url: '/admin/crypto-addresses', method: 'get', params }),
    }),
    // Поиск полного адреса во всех сетях — находит и адреса, которых ещё нет в ночной статистике
    searchCryptoAddresses: builder.query({
      query: (q) => ({ url: '/admin/crypto-addresses/search', method: 'get', params: { q } }),
    }),
    getCryptoAddressCard: builder.query({
      query: ({ network, address }) => ({
        url: '/admin/crypto-addresses/card',
        method: 'get',
        params: { network, address },
      }),
      providesTags: ['CryptoAddressCard'],
    }),
    getCryptoAddressTransactions: builder.query({
      query: (params) => ({ url: '/admin/crypto-addresses/transactions', method: 'get', params }),
    }),
    getCryptoAddressUsers: builder.query({
      query: (params) => ({ url: '/admin/crypto-addresses/users', method: 'get', params }),
    }),
    // История проверок листается курсором («Показать ещё»), страницы копит вкладка
    getKytChecks: builder.query({
      query: (params) => ({ url: '/admin/crypto-addresses/kyt/checks', method: 'get', params }),
    }),
    getKytRaw: builder.query({
      query: ({ network, address, checkSk }) => ({
        url: '/admin/crypto-addresses/kyt/raw',
        method: 'get',
        params: { network, address, check_sk: checkSk },
      }),
    }),
    // expected — текст метки, который видит сотрудник. При 409 метку уже поменяли: карточку перезапрашиваем и тогда
    setCryptoAddressLabel: builder.mutation({
      query: (body) => ({ url: '/admin/crypto-addresses/label', method: 'put', body }),
      invalidatesTags: (result, error) => (!error || error.status === 409 ? ['CryptoAddressCard'] : []),
    }),
    deleteCryptoAddressLabel: builder.mutation({
      query: (body) => ({ url: '/admin/crypto-addresses/label', method: 'delete', body }),
      invalidatesTags: (result, error) => (!error || error.status === 409 ? ['CryptoAddressCard'] : []),
    }),
    // Блэклист: списки по статусам, история адреса и история за период — всё сбрасывается сменой статуса
    getBlacklist: builder.query({
      query: (params) => ({ url: '/admin/crypto-addresses/blacklist', method: 'get', params }),
      providesTags: ['CryptoAddressBlacklist'],
    }),
    getBlacklistHistory: builder.query({
      query: ({ network, address }) => ({
        url: '/admin/crypto-addresses/blacklist/history',
        method: 'get',
        params: { network, address },
      }),
      providesTags: ['CryptoAddressBlacklist'],
    }),
    // «История» за период листается курсором, страницы копит вкладка. Тег не вешаем: перезапрос одной страницы
    // по инвалидации накопленный список не обновит — вкладка и так читает заново при каждом открытии
    getBlacklistLog: builder.query({
      query: (params) => ({ url: '/admin/crypto-addresses/blacklist/log', method: 'get', params }),
    }),
    // expected_status — статус, который видит сотрудник. При 409 статус уже поменяли: перезапрашиваем и тогда
    setBlacklistStatus: builder.mutation({
      query: (body) => ({ url: '/admin/crypto-addresses/blacklist', method: 'put', body }),
      invalidatesTags: (result, error) =>
        !error || error.status === 409 ? ['CryptoAddressCard', 'CryptoAddressBlacklist'] : [],
    }),
  }),
});

export const {
  useGetCryptoAddressesQuery,
  useLazySearchCryptoAddressesQuery,
  useGetCryptoAddressCardQuery,
  useLazyGetCryptoAddressCardQuery,
  useGetCryptoAddressTransactionsQuery,
  useGetCryptoAddressUsersQuery,
  useLazyGetKytChecksQuery,
  useGetKytRawQuery,
  useSetCryptoAddressLabelMutation,
  useDeleteCryptoAddressLabelMutation,
  useGetBlacklistQuery,
  useGetBlacklistHistoryQuery,
  useLazyGetBlacklistLogQuery,
  useSetBlacklistStatusMutation,
} = cryptoAddressesApi;
